/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import { AmplifyEventBus } from "aws-amplify-vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/info",
      component: () => import("@/views/Info.vue"),
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/",
          name: "page-login",
          component: () => import("@/views/pages/Login.vue"),
        },
        {
          path: "/alterar-senha",
          name: "change-password",
          props: true,
          component: () => import("@/views/pages/ChangePassword.vue"),
        },
        {
          path: "/recuperar-senha",
          name: "recover-password",
          props: true,
          component: () => import("@/views/pages/RecoverPassword.vue"),
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
        },
        {
          path: "/acesso-restrito",
          name: "restrict-access",
          component: () => import("@/views/pages/RestrictAccess.vue"),
        },
        {
          path: "/participante/:uuid([\\w\\d]{8}-[\\w\\d]{4}-[\\w\\d]{4}-[\\w\\d]{4}-[\\w\\d]{12})",
          name: "participant",
          component: () => import("@/views/pages/Participant.vue"),
          props: (route) => {
            return {
              caravanistUuid: route.params.uuid,
              caravanistName: route.query.name ? route.query.name : "",
            };
          },
        },
      ],
    },
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "/dashboard",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "",
          name: "home",
          component: () => import("./views/Home.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/page-2",
          name: "page-2",
          component: () => import("./views/Page2.vue"),
          meta: { requiresAuth: true },
        },
        // =============================================================================
        // Gravações
        // =============================================================================
        {
          path: "/gravacoes",
          name: "gravacoes",
          component: () => import("./views/pages/recordings/RecordingList.vue"),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              { title: "Início", url: "/dashboard" },
              { title: "Gravações", active: true },
            ],
            pageTitle: "Gravações",
          },
        },
        {
          path: "/gravacoes/:id(\\d+)",
          name: "gravacoes-detalhes",
          component: () =>
            import("./views/pages/recordings/RecordingDetails.vue"),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              { title: "Início", url: "/dashboard" },
              { title: "Gravações", url: "/gravacoes" },
              { title: "Detalhes", active: true },
            ],
            pageTitle: "Detalhes da Gravação",
          },
        },
        // =============================================================================
        // Contatos
        // =============================================================================
        {
          path: "/contatos",
          name: "contatos",
          component: () =>
            import("./views/pages/participants/ParticipantList.vue"),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              { title: "Início", url: "/dashboard" },
              { title: "Contatos", active: true },
            ],
            pageTitle: "Contatos",
          },
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404",
    },
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

router.beforeResolve(async (to, from, next) => {
  // // If it was not Chrome browser
  // if (navigator.userAgent && navigator.userAgent.toLowerCase().indexOf("chrome") == -1 && to.name !== 'restrict-access') {
  //   // Redirect to a message screen
  //   next({
  //     path: "/acesso-restrito"
  //   });
  //   return;
  // }

  if (to.matched.some((record) => record.meta && record.meta.requiresAuth)) {
    try {
      // Check if user is authenticated
      await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
      next();
    } catch (e) {
      // Redirect user to login page
      next({
        path: "/",
        query: {
          redirect: to.fullPath,
        },
      });
    }
    return;
  }
  next();
});

AmplifyEventBus.$on("authState", (eventInfo) => {
  if (eventInfo === "signedIn") {
    router.push({ name: "home" }).catch((err) => {});
  } else if (eventInfo === "signedOut") {
    router.push({ name: "page-login" }).catch((err) => {});
  }
});

export default router;
